import { getDocument } from './reducers/documents';

// eslint-disable-next-line import/no-default-export
export default {
    REPORTING_GET_DOCUMENT: getDocument,
};
